//PC页面
import Login from './components/login.vue';     //登录页
import range from './components/range.vue'      //切换课程
import Index from './components/index.vue'      //首页
import Photo from './components/photo.vue'      //摄像头测试
import CourseInfo from './components/courseInfo.vue'    //课程学习页
import test from './components/course_info/test.vue'    //在线考试
import exercise from './components/course_info/exercise.vue'    //题库练习
import exercise_result from './components/course_info/exercise_result.vue'    //题库结果
import exercise_err from './components/course_info/exercise_err.vue'    //题库错题页
import wrong_question_book from './components/course_info/wrong_question_book.vue'    //错题本
// import exc_simulation from './components/course_info/exc_simulation.vue'    //题库模拟考
import jieguo from './components/course_info/jieguo.vue'    //在线考试
import Xiaozu from './components/xiaozu.vue'    //学习小组
import kaoshi from "./components/renwu/kaoshi.vue";		//学习任务-考试安排
import kebiao from "./components/renwu/kebiao.vue";		//学习任务-课程表
import zuoye from "./components/renwu/zuoye.vue";			//学习任务-作业
import chengji from "./components/chengji.vue";			//成绩查询
import biji from "./components/biji.vue";					//我的笔记
import tongji from "./components/tongji.vue";				//学习统计
import userIndex from "./components/userCenter/index.vue";	//个人信息
import purchased from "./components/userCenter/purchased.vue";	//个人信息
import name_attestation from "./components/userCenter/name_attestation.vue";	//实名认证
import live_broadcast from "./components/live/list.vue";      //直播列表
import problem from "./components/info/problem.vue";      //常见问题
import guide from "./components/info/guide.vue";      //报考指南
import guide_text from "./components/info/guide_text.vue";      //指南/问题详情
import material from "./components/info/material.vue";      //资料汇总
import material_play from "./components/info/material_play.vue";      //资料查看
import notify from "./components/notify/index.vue";      //通知列表
import notify_info from "./components/notify/notify_info.vue";      //通知详情
import own_examination from "./components/own_examination.vue";      //我的自考
import course_selection from './components/course_selection.vue';    //选课中心
import certificate_download from './components/certificate_download.vue';    //证件下载
import announcement_list from './components/notice_announcement/announcement_list.vue';    //通知公告
import exam_list from './components/course_info/exam_list.vue';    //我的考试
import paper from './components/renwu/paper.vue';    //论文信息
import course_selection_center from './components/renwu/course_selection_center.vue';    //选课中心
import userDetail from './components/user_detail.vue';     //用户信息页
import graduate_form from './components/userCenter/graduate_form.vue';    //通知公告

//WAP页面
// import wapLogin from './wap/login.vue';     //登录页

const routers = {};
var router = [];
var menu = {
    userIndex: {
        path: '/web/userIndex/',
        name: 'userIndex',
        component: userIndex,
        meta: {
            title: "个人信息"
        }
    },
    test:{
        path: '/web/courseInfo/test',
        name: 'test',
        component: test,
        meta: {
            title: "在线考试"
        }
    },
    exercise:{
        path: '/web/courseInfo/exercise',
        name: 'exercise',
        component: exercise,
        meta: {
            title: "题库练习"
        }
    },
    wrong_question_book:{
        path: '/web/courseInfo/wrong_question_book',
        name: 'wrong_question_book',
        component: wrong_question_book,
        meta: {
            title: "错题本"
        }
    },
    exercise_result:{
        path: '/web/courseInfo/exercise_result',
        name: 'exercise_result',
        component: exercise_result,
        meta: {
            title: "练习结果"
        }
    },
    exercise_err:{
        path: '/web/courseInfo/exercise_err',
        name: 'exercise_err',
        component: exercise_err,
        meta: {
            title: "题库错题页"
        }
    },
    // exc_simulation:{
    //     path: '/web/courseInfo/exc_simulation',
    //     name: 'exc_simulation',
    //     component: exc_simulation,
    //     meta: {
    //         title: "题库模拟考"
    //     }
    // },
    jieguo:{
        path: '/web/courseInfo/jieguo',
        name: 'jieguo',
        component: jieguo,
        meta: {
            title: "考试结果"
        }
    },
    tongji:{
        path: '/web/tongji/',
        name: 'tongji',
        component: tongji,
        meta: {
            title: "学习统计"
        }
    },
    biji:{
        path: '/web/biji/',
        name: 'biji',
        component: biji,
        meta: {
            title: "我的笔记"
        }
    },
    live_broadcast:{
        path: '/web/live/list',
        name: 'live_broadcast',
        component: live_broadcast,
        meta: {
            title: "直播列表"
        }
    },
    guide:{
        path: '/web/guide',
        name: 'guide',
        component: guide,
        meta: {
            title: "报考指南"
        }
    },
    guide_text:{
        path: '/web/guide_text',
        name: 'guide_text',
        component: guide_text,
        meta: {
            title: "详情"
        }
    },
    problem:{
        path: '/web/problem',
        name: 'problem',
        component: problem,
        meta: {
            title: "常见问题"
        }
    },
    material:{
        path: '/web/material',
        name: 'material',
        component: material,
        meta: {
            title: "资料汇总"
        }
    },
    material_play:{
        path: '/web/material_play',
        name: 'material_play',
        component: material_play,
        meta: {
            title: "视频查看"
        }
    },
    chengji:{
        path: '/web/chengji/',
        name: 'chengji',
        component: chengji,
        meta: {
            title: "成绩查询"
        }
    },
    zuoye:{
        path: '/web/zuoye/',
        name: 'zuoye',
        component: zuoye,
        meta: {
            title: "我的作业"
        }
    },
    kebiao:{
        path: '/web/kebiao/',
        name: 'kebiao',
        component: kebiao,
        meta: {
            title: "课程表"
        }
    },
    kaoshi:{
        path: '/web/kaoshi/',
        name: 'kaoshi',
        component: kaoshi,
        meta: {
            title: "考试安排"
        }
    },
    xiaozu:{
        path: '/web/xiaozu/',
        name: 'xiaozu',
        component: Xiaozu,
        meta: {
            title: "学习小组"
        }
    },
    courseInfo:{
        path: '/web/courseInfo/',
        name: 'courseInfo',
        component: CourseInfo,
        meta: {
            title: "课程学习"
        }
    },
    index:{
        path: '/web/index/',
        name: 'index',
        component: Index,
        meta: {
            title: "首页"
        }
    },
    range:{
        path: '/web/range/',
        name: 'range',
        component: range,
        meta: {
            title: "首页"
        }
    },
    purchased:{
        path: '/web/purchased/',
        name: 'purchased',
        component: purchased,
        meta: {
            title: "已购课程"
        }
    },
    name_attestation:{
        path: '/web/name_attestation/',
        name: 'name_attestation',
        component: name_attestation,
        meta: {
            title: "已购课程"
        }
    },
    logs:{
        path: '/web/logs',
        name: 'logs',
        component: () => import("./components/userCenter/logs"),
        meta: {
            title: "操作日志"
        }
    },
    photo:{
        path: '/web/photo/',
        name: 'photo',
        component: Photo,
        meta: {
            title: "摄像头"
        }
    },
    notify:{
        path: '/web/notify/',
        name: 'notify',
        component: notify,
        meta: {
            title: "消息通知"
        }
    },
    notify_info:{
        path: '/web/notify/notify_info',
        name: 'notify_info',
        component: notify_info,
        meta: {
            title: "消息详情"
        }
    },
    live_room:{
        path: '/web/live/room',
        name: 'live_room',
        component: () => import("./components/live/room"),
        meta: {
            title: "直播间"
        }
    },
    own_examination:{
        path: '/web/own_examination/',
        name: 'own_examination',
        component: own_examination,
        meta: {
            title: "我的自考"
        }
    },
    course_selection:{
        path: '/web/course_selection/',
        name: 'course_selection',
        component: course_selection,
        meta: {
            title: "选课中心"
        }
    },
    course_selection_center:{
        path: '/web/course_selection_center/',
        name: 'course_selection_center',
        component: course_selection_center,
        meta: {
            title: "选课中心"
        }
    },
    certificate_download:{
        path: '/web/certificate_download/',
        name: 'certificate_download',
        component: certificate_download,
        meta: {
            title: "证件下载"
        }
    },
    announcement_list:{
        path: '/web/announcement_list/',
        name: 'announcement_list',
        component: announcement_list,
        meta: {
            title: "通知列表"
        }
    },
    exam_list:{
        path: '/web/exam_list',
        name: 'exam_list',
        component: exam_list,
        meta: {
            title: "我的考试"
        }
    },
    exam_list_en:{
        path: '/web/exam_list_en',
        name: 'exam_list_en',
        component: () => import("./components/course_info/exam_list_en"),
        meta: {
            title: "我的考试"
        }
    },
    exam_sign_list:{
        path: '/web/exam_sign_list',
        name: 'exam_sign_list',
        component: () => import("./components/course_info/exam_sign_list"),
        meta: {
            title: "我的考试"
        }
    },
    exam_sign_detail:{
        path: '/web/exam_sign_detail',
        name: 'exam_sign_detail',
        component: () => import("./components/course_info/exam_sign_detail"),
        meta: {
            title: "我的考试"
        }
    },
    paper:{
        path: '/web/paper',
        name: 'paper',
        component: paper,
        meta: {
            title: "论文信息"
        }
    },
    paper:{
        path: '/web/paper',
        name: 'paper',
        component: paper,
        meta: {
            title: "论文信息"
        }
    },
    graduate_form:{
        path: '/web/graduate_form/',
        name: 'graduate_form',
        component: graduate_form,
        meta: {
            title: "毕业信息"
        }
    },
    userDetail:{
        path: '/web/user_detail',
        name: 'user_detail',
        component: userDetail,
        meta: {
            title: "用户详情"
        }
    },
    trialsCourseInfo:{
        path: '/trials/courseInfo',
        name: 'trialsCourseInfo',
        component: () => import("./components/trials/courseInfo"),
        meta: {
            title: "试看课程页"
        }
    },
}
// var wap = {
//     wapLogin: {
//         path: '/wap/login/',
//         name: 'wapLogin',
//         component: wapLogin,
//         meta: {
//             title: "个人信息"
//         }
//     },
// }
var login=[
    {
        path: '/web/login/',
        name: 'login',
        component: Login,
        meta: {
            title: "登录"
        }
    },{
        path: '/web/',
        component: Login,
        meta: {
            title: "登录"
        }
    },{
        path: '/',
        redirect: '/web/login/'
    }
]
routers.menu = menu;
routers.login = login;
// routers.wap = wap;
for(var index in menu){
    router.push(menu[index])
}
for(var index in login){
    router.push(login[index])
}
// for(var index in wap){
//     router.push(wap[index])
// }
routers.router = router;
// console.log(routers);
export default routers
    


// WEBPACK FOOTER //
// ./src/routers.js